module.exports = __webpack_public_path__ + "img/icon-add.34b230af.svg";